import styles from 'styles/modules/TitleUnderline.module.scss';

const TitleUnderline = ({ children, className }) => {
    return (
        <div className={[styles.title, className ?? null].join(' ')}>
            {children}
        </div>
    );
};

export default TitleUnderline;
